export default {
  state: {
    barraArrastrar: 0,
    limiteConsultaDocumentos: null,
    filtrosConsultaDocumentos: null,
    variablesFormulariosOverlay: null,
    banderaFormularioExistenteAbiertoOverlay: false,
    variablesActualizadasOverlay: [],
    coleccionOverlay: false,
    banderaFormularioCreadoPanelOverlay: false,
    estados_panel_lateral_vuex: null,
    mensaje_modal: null,
    estado_modal: false,
    icono_modal: null,
    variablesFormularios: null,
    variablesFormulariosInfoGeneral: null,
    valorVariablesFormulariosIngresadas: null,
    idFormularioEnvioDeMensajes: null,
    variablesFormulariosEnvioDeMensajes: null,
    variablesFormulariosIngresadas: null,
    momentosEncuentro: null,
    momentoActual: null,
    momentoActualOverlay: null,
    textoGenerado: null,
    id: null,
    idVerEncuentrosOSeguimiento: null,
    cancelarFormulario: null,
    formulariosExistentes: null,
    nombreVariableActualizar: null,
    valorVariableActualizar: null,
    variablesActualizadas: [],
    variablesActualizadasInfoGeneral: [],
    formulariosMomentosllenos: [],
    banderaFormularioExistenteAbierto: false,
    banderaBotonMas: false,
    nombreEvento: false,
    nombreEventoOverlay: false,
    consultarEncuentro: null,
    consultarEncuentroOverlay: null,
    banderaFormularioCreadoPanel: false,
    cargando: false,
    coleccion: false,
    coleccionInfoGeneral: false,
    consultarFormulario: '',
    prioridadComponente: 1,
    serieFormularios: [],
    esquemaFormularioSerie: null,
    ordenesAutomaticasEncuentro: false,
  },
  getters: {
    getBarraArrastrar: state => state.barraArrastrar,
    getLimiteConsultaDocumentos: state => state.limiteConsultaDocumentos,
    getFiltrosConsultaDocumentos: state => state.filtrosConsultaDocumentos,
    getEsquemaFormularioSerie: state => state.esquemaFormularioSerie,
    getSerieFormularios: state => state.serieFormularios,
    getVariablesFormulariosOverlay: state => state.variablesFormulariosOverlay,
    getBanderaFormularioExistenteAbiertoOverlay: state => state.banderaFormularioExistenteAbiertoOverlay,
    getVariablesActualizadasOverlay: state => state.variablesActualizadasOverlay,
    getColeccionOverlay: state => state.coleccionOverlay,
    getBanderaFormularioCreadoPanelOverlay: state => state.banderaFormularioCreadoPanelOverlay,
    getPrioridadComponente: state => state.prioridadComponente,
    cambiaPanelLateral: state => state.estados_panel_lateral_vuex,
    getEstadoModal: state => state.estado_modal,
    getMensajeModal: state => state.mensaje_modal,
    getIconoModal: state => state.icono_modal,
    getVariablesFormularios: state => state.variablesFormularios,
    getIdFormularioEnvioDeMensajes: state => state.idFormularioEnvioDeMensajes,
    getVariablesFormulariosEnvioDeMensajes: state => state.variablesFormulariosEnvioDeMensajes,
    getVariablesFormulariosInfoGeneral: state => state.variablesFormulariosInfoGeneral,
    getValorVariablesFormulariosIngresadas: state => state.valorVariablesFormulariosIngresadas,
    getVariablesFormulariosIngresadas: state => state.variablesFormulariosIngresadas,
    getMomentosEncuentro: state => state.momentosEncuentro,
    getMomentoActual: state => state.momentoActual,
    getMomentoActualOverlay: state => state.momentoActualOverlay,
    getTextoGenerado: state => state.textoGenerado,
    getId: state => state.id,
    getIdVerEncuentrosOSeguimiento: state => state.idVerEncuentrosOSeguimiento,
    getCancelarFormulario: state => state.cancelarFormulario,
    getFormulariosExistentes: state => state.formulariosExistentes,
    getNombreVariableActualizar: state => state.nombreVariableActualizar,
    getValorVariableActualizar: state => state.valorVariableActualizar,
    getVariablesActualizadas: state => state.variablesActualizadas,
    getVariablesActualizadasInfoGeneral: state => state.variablesActualizadasInfoGeneral,
    getFormulariosMomentosllenos: state => state.formulariosMomentosllenos,
    getBanderaFormularioExistenteAbierto: state => state.banderaFormularioExistenteAbierto,
    getBanderaBotonMas: state => state.banderaBotonMas,
    getNombreEvento: state => state.nombreEvento,
    getNombreEventoOverlay: state => state.nombreEventoOverlay,
    getConsultarEncuentro: state => state.consultarEncuentro,
    getConsultarEncuentroOverlay: state => state.consultarEncuentroOverlay,
    getBanderaFormularioCreadoPanel: state => state.banderaFormularioCreadoPanel,
    getCargando: state => state.cargando,
    getColeccion: state => state.coleccion,
    getColeccionInfoGeneral: state => state.coleccionInfoGeneral,
    getConsultarFormulario: state => state.consultarFormulario,
    getOrdenesAutomaticasEncuentro: state => state.ordenesAutomaticasEncuentro,

  },
  mutations: {
    setBarraArrastrar(state, valor) {
      state.barraArrastrar = valor;
    },

    setLimiteConsultaDocumentos(state, valor) {
      state.limiteConsultaDocumentos = valor;
    },
    setFiltrosConsultaDocumentos(state, valor) {
      state.filtrosConsultaDocumentos = valor;
    },
    setEsquemaFormularioSerie(state, valor) {
      state.esquemaFormularioSerie = valor;
    },
    setSerieFormularios(state, valor) {
      state.serieFormularios = valor;
    },
    agregarFormularioSerie(state, item) {
      if (state.serieFormularios === null) {
        state.serieFormularios = [];
      }
      state.serieFormularios.push(JSON.parse(JSON.stringify(item)));
    },
    eliminarFormularioSerie(state, valor) {
      state.serieFormularios.splice(valor, 1);
    },
    setVariablesFormulariosOverlay(state, valor) {
      state.variablesFormulariosOverlay = valor;
    },
    setBanderaFormularioExistenteAbiertoOverlay(state, valor) {
      state.banderaFormularioExistenteAbiertoOverlay = valor;
    },
    setVariablesActualizadasOverlay(state, valor) {
      state.variablesActualizadasOverlay = valor;
    },
    setColeccionOverlay(state, valor) {
      state.coleccionOverlay = valor;
    },
    setBanderaFormularioCreadoPanelOverlay(state, valor) {
      state.banderaFormularioCreadoPanelOverlay = valor;
    },
    setestadoPanel(state, valor) {
      state.estados_panel_lateral_vuex = valor;
    },
    cambiarEstadoModal(state, estado) {
      state.estado_modal = estado;
    },
    cambiarMensajeModal(state, mensaje) {
      state.mensaje_modal = mensaje;
    },
    cambiarIconoModal(state, src) {
      state.icono_modal = src;
    },
    setVariablesFormularios(state, valor) {
      state.variablesFormularios = valor;
    },
    setVariablesFormulariosInfoGeneral(state, valor) {
      state.variablesFormulariosInfoGeneral = valor;
    },
    setIdFormularioEnvioDeMensajes(state, valor) {
      state.idFormularioEnvioDeMensajes = valor;
    },
    setVariablesFormulariosEnvioDeMensajes(state, valor) {
      state.variablesFormulariosEnvioDeMensajes = valor;
    },
    setValorVariablesFormulariosIngresadas(state, valor) {
      state.valorVariablesFormulariosIngresadas = valor;
    },
    setVariablesFormulariosIngresadas(state, valor) {
      state.variablesFormulariosIngresadas = valor;
    },
    setMomentosEncuentro(state, valor) {
      state.momentosEncuentro = valor;
    },
    setMomentoActual(state, valor) {
      state.momentoActual = valor;
    },
    setMomentoActualOverlay(state, valor) {
      state.momentoActualOverlay = valor;
    },
    setTextoGenerado(state, valor) {
      state.textoGenerado = valor;
    },
    setId(state, valor) {
      state.id = valor;
    },
    setIdVerEncuentrosOSeguimiento(state, valor) {
      state.idVerEncuentrosOSeguimiento = valor;
    },
    setCancelarFormulario(state, valor) {
      state.cancelarFormulario = valor;
    },
    setFormulariosExistentes(state, valor) {
      state.formulariosExistentes = valor;
    },
    setNombreVariableActualizar(state, valor) {
      state.nombreVariableActualizar = valor;
    },
    setValorVariableActualizar(state, valor) {
      state.valorVariableActualizar = valor;
    },
    setVariablesActualizadas(state, valor) {
      state.variablesActualizadas = valor;
    },
    setVariablesActualizadasInfoGeneral(state, valor) {
      state.variablesActualizadasInfoGeneral = valor;
    },
    setFormulariosMomentosllenos(state, valor) {
      state.formulariosMomentosllenos = valor;
    },
    setBanderaFormularioExistenteAbierto(state, valor) {
      state.banderaFormularioExistenteAbierto = valor;
    },
    setBanderaBotonMas(state, valor) {
      state.banderaBotonMas = valor;
    },
    setNombreEvento(state, valor) {
      state.nombreEvento = valor;
    },
    setNombreEventoOverlay(state, valor) {
      state.nombreEventoOverlay = valor;
    },
    setConsultarEncuentro(state, valor) {
      state.consultarEncuentro = valor;
    },
    setConsultarEncuentroOverlay(state, valor) {
      state.consultarEncuentroOverlay = valor;
    },
    setBanderaFormularioCreadoPanel(state, valor) {
      state.banderaFormularioCreadoPanel = valor;
    },
    setCargando(state, valor) {
      state.cargando = valor;
    },
    setColeccion(state, valor) {
      state.coleccion = valor;
    },
    setColeccionInfoGeneral(state, valor) {
      state.coleccionInfoGeneral = valor;
    },
    setConsultarFormulario(state, valor) {
      state.consultarFormulario = valor;
    },
    setPrioridadComponente(state, valor) {
      state.prioridadComponente = valor;
    },
    setOrdenesAutomaticasEncuentro(state, valor) {
      state.ordenesAutomaticasEncuentro = valor;
    },
  },

  actions: {
    setBarraArrastrar(context, valor) {
      context.commit('setBarraArrastrar', valor);
    },

    setLimiteConsultaDocumentos(context, valor) {
      context.commit('setLimiteConsultaDocumentos', valor);
    },
    setFiltrosConsultaDocumentos(context, valor) {
      context.commit('setFiltrosConsultaDocumentos', valor);
    },
    setEsquemaFormularioSerie(context, valor) {
      context.commit('setEsquemaFormularioSerie', valor);
    },
    setSerieFormularios(context, valor) {
      context.commit('setSerieFormularios', valor);
    },
    setVariablesFormulariosOverlay(context, valor) {
      context.commit('setVariablesFormulariosOverlay', valor);
    },
    setBanderaFormularioExistenteAbiertoOverlay(context, valor) {
      context.commit('setBanderaFormularioExistenteAbiertoOverlay', valor);
    },
    setVariablesActualizadasOverlay(context, valor) {
      context.commit('setVariablesActualizadasOverlay', valor);
    },
    setColeccionOverlay(context, valor) {
      context.commit('setColeccionOverlay', valor);
    },
    setBanderaFormularioCreadoPanelOverlay(context, valor) {
      context.commit('setBanderaFormularioCreadoPanelOverlay', valor);
    },
    setestadoPanel(context, estado) {
      context.commit('setestadoPanel', estado);
    },
    cambiarEstadoModal(context, estado) {
      context.commit('cambiarEstadoModal', estado);
    },
    cambiarMensajeModal(context, mensaje) {
      context.commit('cambiarMensajeModal', mensaje);
    },
    cambiarIconoModal(context, src) {
      context.commit('cambiarIconoModal', src);
    },
    setVariablesFormularios(context, valor) {
      context.commit('setVariablesFormularios', valor);
    },
    setVariablesFormulariosInfoGeneral(context, valor) {
      context.commit('setVariablesFormulariosInfoGeneral', valor);
    },
    setIdFormularioEnvioDeMensajes(context, valor) {
      context.commit('setIdFormularioEnvioDeMensajes', valor);
    },
    setVariablesFormulariosEnvioDeMensajes(context, valor) {
      context.commit('setVariablesFormulariosEnvioDeMensajes', valor);
    },
    setValorVariablesFormulariosIngresadas(context, valor) {
      context.commit('setValorVariablesFormulariosIngresadas', valor);
    },
    setVariablesFormulariosIngresadas(context, valor) {
      context.commit('setVariablesFormulariosIngresadas', valor);
    },
    setMomentosEncuentro(context, valor) {
      context.commit('setMomentosEncuentro', valor);
    },
    setMomentoActual(context, valor) {
      context.commit('setMomentoActual', valor);
    },
    setMomentoActualOverlay(context, valor) {
      context.commit('setMomentoActualOverlay', valor);
    },
    setTextoGenerado(context, valor) {
      context.commit('setTextoGenerado', valor);
    },
    setId(context, valor) {
      context.commit('setId', valor);
    },
    setIdVerEncuentrosOSeguimiento(context, valor) {
      context.commit('setIdVerEncuentrosOSeguimiento', valor);
    },
    setCancelarFormulario(context, valor) {
      context.commit('setCancelarFormulario', valor);
    },
    setFormulariosExistentes(context, valor) {
      context.commit('setFormulariosExistentes', valor);
    },
    setNombreVariableActualizar(context, valor) {
      context.commit('setNombreVariableActualizar', valor);
    },
    setValorVariableActualizar(context, valor) {
      context.commit('setValorVariableActualizar', valor);
    },
    setVariablesActualizadas(context, valor) {
      context.commit('setVariablesActualizadas', valor);
    },
    setVariablesActualizadasInfoGeneral(context, valor) {
      context.commit('setVariablesActualizadasInfoGeneral', valor);
    },
    setFormulariosMomentosllenos(context, valor) {
      context.commit('setFormulariosMomentosllenos', valor);
    },
    setBanderaFormularioExistenteAbierto(context, valor) {
      context.commit('setBanderaFormularioExistenteAbierto', valor);
    },
    setBanderaBotonMas(context, valor) {
      context.commit('setBanderaBotonMas', valor);
    },
    setNombreEvento(context, valor) {
      context.commit('setNombreEvento', valor);
    },
    setNombreEventoOverlay(context, valor) {
      context.commit('setNombreEventoOverlay', valor);
    },
    setConsultarEncuentro(context, valor) {
      context.commit('setConsultarEncuentro', valor);
    },
    setConsultarEncuentroOverlay(context, valor) {
      context.commit('setConsultarEncuentroOverlay', valor);
    },
    setBanderaFormularioCreadoPanel(context, valor) {
      context.commit('setBanderaFormularioCreadoPanel', valor);
    },
    setCargando(context, valor) {
      context.commit('setCargando', valor);
    },
    setColeccion(context, valor) {
      context.commit('setColeccion', valor);
    },
    setColeccionInfoGeneral(context, valor) {
      context.commit('setColeccionInfoGeneral', valor);
    },
    setConsultarFormulario(context, valor) {
      context.commit('setConsultarFormulario', valor);
    },
    setPrioridadComponente(context, valor) {
      context.commit('setPrioridadComponente', valor);
    },
    setOrdenesAutomaticasEncuentro(context, valor) {
      context.commit('setOrdenesAutomaticasEncuentro', valor);
    },
  },
};



// WEBPACK FOOTER //
// ./src/js/modules/HistoriaClinica.js